import { createSelector } from 'reselect';
import { IStore } from '../reducers';
import { IWalletTags } from '@kattana-io/common';

const createGetFromWalletTags = (wallet?: string, network?: string) =>
  createSelector(
    (state: IStore) => state.walletTags,
    (walletTags: IWalletTags): string | undefined => {
      if (wallet && network) {
        return walletTags[`${network}`]?.[`${wallet}`]?.[0];
      }
      return undefined;
    }
  );

export { createGetFromWalletTags };
